export default __webpack_public_path__ + "media/images/fp_footer-ee2ccd910f94a0404b2d580a2987102e.png";